import React from 'react'
import { Controller, Control, FieldErrors } from 'react-hook-form'
import BaseQuestion from '../base-question'
import s from '../styles.module.css'

interface BooleanQuestionProps {
  question: {
    id: number
    text: string
    isRequired?: boolean
    type: string
  }
  // RHF mode
  control?: Control<any>
  errors?: FieldErrors<any>
  // Zustand mode
  value?: boolean
  error?: string
  onChange?: (value: boolean) => void
}

const BooleanQuestion: React.FC<BooleanQuestionProps> = ({
  question,
  control,
  errors,
  value,
  error,
  onChange,
}) => {
  const isRHFMode = !!control && !!errors

  if (isRHFMode) {
    // RHF mode - use Controller
    return (
      <BaseQuestion question={question} control={control} errors={errors}>
        <div className={s.responses}>
          <Controller
            name={`question_${question.id}`}
            control={control}
            rules={{
              required: question.isRequired ? 'This field is required' : false,
            }}
            render={({ field }) => (
              <>
                <label
                  key="yes"
                  className={`${s.responseOption} ${
                    field.value === true ? s.selected : ''
                  }`}>
                  <input
                    type="radio"
                    {...field}
                    value="true"
                    checked={field.value === true}
                    onChange={() => field.onChange(true)}
                    className={s.responseInput}
                  />
                  <span className={s.responseText}>Yes</span>
                </label>
                <label
                  key="no"
                  className={`${s.responseOption} ${
                    field.value === false ? s.selected : ''
                  }`}>
                  <input
                    type="radio"
                    {...field}
                    value="false"
                    checked={field.value === false}
                    onChange={() => field.onChange(false)}
                    className={s.responseInput}
                  />
                  <span className={s.responseText}>No</span>
                </label>
              </>
            )}
          />
        </div>
      </BaseQuestion>
    )
  } else {
    // Zustand mode - use direct props
    return (
      <BaseQuestion question={question} error={error}>
        <div className={s.responses}>
          <label
            key="yes"
            className={`${s.responseOption} ${
              value === true ? s.selected : ''
            }`}>
            <input
              type="radio"
              value="true"
              checked={value === true}
              onChange={() => onChange?.(true)}
              className={s.responseInput}
            />
            <span className={s.responseText}>Yes</span>
          </label>
          <label
            key="no"
            className={`${s.responseOption} ${
              value === false ? s.selected : ''
            }`}>
            <input
              type="radio"
              value="false"
              checked={value === false}
              onChange={() => onChange?.(false)}
              className={s.responseInput}
            />
            <span className={s.responseText}>No</span>
          </label>
        </div>
      </BaseQuestion>
    )
  }
}

export default BooleanQuestion
